import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { TLocale } from '../translations';
import Cookies from 'js-cookie';
import { COOKIES_KEYS } from '../app-constants/constants';
import { generateTimeOptions } from '@jadwalh/utils';

const currentLang: TLocale =
  localStorage.getItem('lang') === 'en' ? 'en' : 'ar';
const initialState: TLocale = currentLang;

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    changLang: (state, { payload: { lang } }) => {
      // document.documentElement.lang = lang;
      // document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      // localStorage.setItem('lang', lang);
      // Cookies.set(COOKIES_KEYS.LanguageAdded, lang);
      // generateTimeOptions(lang);
      document.documentElement.lang = 'ar';
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'rtl';
      localStorage.setItem('lang', 'ar');
      Cookies.set(COOKIES_KEYS.LanguageAdded, 'ar');
      generateTimeOptions('ar');
      return lang;
      return lang;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changLang } = langSlice.actions;

export const getLangState = (state: RootState) => state.lang;

export default langSlice.reducer;
